import Notification from '@components/ui/Notification'
import styles from './styles.module.scss'

type FeedbackStatusMessagesProps = {
  serverError: string | null
  successMessage: string | null
  hasFieldErrors: boolean
  isSubmitted: boolean
}

export default function UnsubscribeFeedbackStatusMessages({
  serverError,
  successMessage,
  hasFieldErrors,
  isSubmitted
}: FeedbackStatusMessagesProps) {
  const shouldShowError = serverError || (isSubmitted && hasFieldErrors)

  return (
    <>
      {shouldShowError && (
        <div className={styles.NotificationBanner}>
          <Notification type="error">
            <p>
              {serverError
                ? serverError
                : 'We think you might have missed a question. Please review your answers.'}
            </p>
          </Notification>
        </div>
      )}

      {successMessage && (
        <div className={styles.NotificationBanner}>
          <Notification type="success">
            <p>{successMessage}</p>
          </Notification>
        </div>
      )}
    </>
  )
}
